import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const publicRoutes = [
  "/signin",
  "/verifyEmail",
  "/resetpassword",
  "/coming-soon",
];

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem("token");

  // Public routes → allow without checks
  if (publicRoutes.includes(location.pathname)) {
    return children;
  }

  // No token → redirect to login
  if (!token) {
    localStorage.clear();
    sessionStorage.clear();
    return <Navigate to="/verifyEmail" replace />;
  }

  // Otherwise → let the request interceptor (baseApi) handle expiry
  return children;
};

export default ProtectedRoute;
